import GeneralAspectModule from "./GeneralAspectModule";
import HeaderModule from "./HeaderModule";
import FontSizeModule from "./FontSizeModule";
import CarouselModule from "./CarouselModule";
import SeparatorModule from "./SeparatorModule";
import LayoutModule from "./LayoutModule";

export const MenuDesignModules = ({
  t,
  styleOption,
  dataInstance,
  googleFonts,
  register,
  errors,
  handleOnChangeData,
  handleFieldImageManager,
  handleOpenImageManager,
  handleChangeCompletePicker,
  handleChangeDataBoolean,
  handleChangeCompleteGradientPicker
}) => {
  return (<>
    {styleOption === 1 ? <div>
      <GeneralAspectModule
        t={t}
        dataInstance={dataInstance}
        googleFonts={googleFonts}
        register={register}
        errors={errors}
        changeDataFunction={handleOnChangeData}
        setFieldImageManager={handleFieldImageManager}
        openImageManager={handleOpenImageManager}
        changeCompletePicker={handleChangeCompletePicker} />
    </div> : null}
    {styleOption === 2 ? <div>
      <HeaderModule
        t={t}
        dataInstance={dataInstance}
        register={register}
        errors={errors}
        changeDataFunction={handleOnChangeData}
        setFieldImageManager={handleFieldImageManager}
        openImageManager={handleOpenImageManager}
        changeCompletePicker={handleChangeCompletePicker} />
    </div> : null}
    {styleOption === 3 ? <div>
      <CarouselModule
        t={t}
        dataInstance={dataInstance}
        googleFonts={googleFonts}
        register={register}
        errors={errors}
        changeDataFunction={handleOnChangeData}
        setFieldImageManager={handleFieldImageManager}
        openImageManager={handleOpenImageManager}
        changeCompletePicker={handleChangeCompletePicker}
        changeDataBoolean={handleChangeDataBoolean} />
    </div> : null}
    {styleOption === 4 ? <div>
      <SeparatorModule
        t={t}
        dataInstance={dataInstance}
        register={register}
        errors={errors}
        changeDataFunction={handleOnChangeData}
        changeColorGradient={handleChangeCompleteGradientPicker} />
    </div> : null}
    {styleOption === 5 ? <div>
      <FontSizeModule
        t={t}
        dataInstance={dataInstance}
        register={register}
        errors={errors}
        changeDataFunction={handleOnChangeData} />
    </div> : null}
    {styleOption === 6 ? <div>
      <LayoutModule
        t={t}
        dataInstance={dataInstance}
        register={register}
        errors={errors}
        changeDataFunction={handleOnChangeData} />
    </div> : null}
  </>)
}